var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sb-banner-button",attrs:{"disabled":_vm.disabled}},[_c('h1',{},[_c('div',[_vm._v(_vm._s(_vm.$t('EM_DASH'))),_vm._t("default"),_vm._v(_vm._s(_vm.$t('EM_DASH')))],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }